import React, { useContext, useEffect, useState } from 'react';
import { AuthContext } from '../context/AuthContext';
import moment from 'moment';
import { Link } from 'react-router-dom';
import CartIcon from '../assets/img/MblEmptyCart.png';
import CrossImg from '../assets/img/x-black.png';
import { Modal, ModalBody } from 'react-bootstrap';
import axios from 'axios';
import { toast } from 'react-toastify';

const Cart = () => {
  const {
    carts,
    setCartsItem,
    setIsLocalLab,
    labDiscountArray,
    setLastCartPatient,
  } = useContext(AuthContext);

  const [cartCheckout, setCartCheckout] = useState([]);
  const [patinetOrders, setPatinetOrders] = useState([]);
  const [showCouponSection, setShowCouponSection] = useState(false);
  const [showPaymentViewMore, setShowPaymentViewMore] = useState(false);

  const [cartOrderType, setCartOrderType] = useState('diagnostic');

  const [materialPerson, setMaterialPerson] = useState(null);
  const [fees, setFees] = useState({
    meterial_fee: 0,
    collection_fee: 0,
    delivery_fee: 0,
  });
  const [feesApi, setFeesApi] = useState({
    meterial_fee: 0,
    collection_fee: 0,
    collection_fee_extend: 0,
    delivery_fee: 0,
    inactive_test: false,
    test: null,
  });
  // Raw fee rules from the API, kept so material fee can be evaluated per
  // patient (each patient's own tests may match a different rule) instead
  // of using a single rule for the whole order.
  const [feeRules, setFeeRules] = useState([]);
  const [deliveryCopy, setDeliveryCopy] = useState('both');
  const [labDiscount, setLabDiscount] = useState(null);
  const [discountAmount, setDiscountAmount] = useState(null);
  const [coupon, setCoupon] = useState('');
  const [showDiscount, setShowDiscount] = useState(false);
  const [cuponId, setcuponId] = useState(null);
  const [checkUserType, setCheckUserType] = useState(null);

  useEffect(() => {
    // console.log(carts);
    handlePatientOrders(carts);
    handleMeterialPerson(carts);
    setCartCheckout(carts);
    if (labDiscountArray) {
      calculateLabDiscount(labDiscountArray);
    }

    if (carts && carts.length !== 0) {
      if (carts[0].order_type === 'diagnostic') {
        setCartOrderType('diagnostic');
      }

      if (carts[0].order_type === 'package') {
        setCartOrderType('package');
      }
    }
  }, [carts]);

  useEffect(() => {
    // console.log(labDiscountArray);
    if (labDiscountArray) {
      setTimeout(() => {
        calculateLabDiscount(labDiscountArray);
      }, 500);
    }
  }, [labDiscountArray]);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  useEffect(() => {
    const userId = localStorage.getItem('user_id');
    if (userId) {
      userOrderCheck(JSON.parse(userId));
    }
  }, []);

  useEffect(() => {
    if (labDiscountArray) {
      calculateLabDiscount(labDiscountArray);
    }
  }, [checkUserType]);

  useEffect(() => {
    getFees(carts || []);
  }, [carts, deliveryCopy]);

  const userOrderCheck = (id) => {
    axios
      .get(`${process.env.REACT_APP_BASE_URL}/order/user-order-exist/${id}`)
      .then((resp) => {
        setCheckUserType(resp.data.exist ? 'old' : 'new');
      })
      .catch(() => {});
  };

  const isLabDiscountAllowedForUser = (coupon) => {
    if (!coupon) return false;
    if (checkUserType !== 'old') return true;
    return coupon.new_user_only !== true;
  };

  const getEligibleLabDiscounts = (discounts = []) => {
    if (!Array.isArray(discounts)) return [];
    return discounts.filter((coupon) => isLabDiscountAllowedForUser(coupon));
  };

  const getDefaultFeeConfig = () => ({
    id: null,
    created_at: null,
    meterial_fee: 0,
    collection_fee: 0,
    collection_fee_extend: 0,
    delivery_fee: 0,
    inactive_test: false,
    test: null,
  });

  const normalizeFeeConfig = (feeData = {}) => {
    const feeTestId =
      feeData && feeData.test && typeof feeData.test === 'object'
        ? parseInt(feeData.test.id)
        : feeData && feeData.test
          ? parseInt(feeData.test)
          : null;

    return {
      ...getDefaultFeeConfig(),
      ...feeData,
      id: feeData && feeData.id ? parseInt(feeData.id) : null,
      meterial_fee: parseInt(feeData.meterial_fee) || 0,
      collection_fee: parseInt(feeData.collection_fee) || 0,
      collection_fee_extend: parseInt(feeData.collection_fee_extend) || 0,
      delivery_fee: parseInt(feeData.delivery_fee) || 0,
      inactive_test:
        typeof feeData.inactive_test === 'boolean'
          ? feeData.inactive_test
          : false,
      test: feeTestId,
      created_at: feeData && feeData.created_at ? feeData.created_at : null,
    };
  };

  const getFeeConfigsFromApi = (resp) => {
    const feeRows =
      resp &&
      resp.data &&
      Array.isArray(resp.data.results)
        ? resp.data.results
        : resp && resp.data && Array.isArray(resp.data)
          ? resp.data
          : [];

    if (!feeRows.length) {
      return [getDefaultFeeConfig()];
    }

    return feeRows
      .map((item) => normalizeFeeConfig(item))
      .sort((a, b) => {
        const dateA = new Date(a.created_at || 0).getTime();
        const dateB = new Date(b.created_at || 0).getTime();
        if (dateA !== dateB) {
          return dateB - dateA;
        }
        return (b.id || 0) - (a.id || 0);
      });
  };

  const getCartTestMeta = (cart = {}) => {
    if (!cart) {
      return { testId: null, isActive: null };
    }

    if (cart.order_type === 'diagnostic') {
      const testItem = cart.test_item || null;
      const diagnosticTest =
        testItem && testItem.diagnostic_test ? testItem.diagnostic_test : null;
      return {
        testId: diagnosticTest && diagnosticTest.id ? parseInt(diagnosticTest.id) : null,
        isActive:
          diagnosticTest && typeof diagnosticTest.is_active === 'boolean'
            ? diagnosticTest.is_active
            : testItem && typeof testItem.is_active === 'boolean'
              ? testItem.is_active
              : null,
      };
    }

    if (cart.order_type === 'package') {
      const packageTestItem =
        cart && cart.package && cart.package.test_item ? cart.package.test_item : null;
      const diagnosticTest =
        packageTestItem && packageTestItem.diagnostic_test
          ? packageTestItem.diagnostic_test
          : null;
      return {
        testId: diagnosticTest && diagnosticTest.id ? parseInt(diagnosticTest.id) : null,
        isActive:
          diagnosticTest && typeof diagnosticTest.is_active === 'boolean'
            ? diagnosticTest.is_active
            : packageTestItem && typeof packageTestItem.is_active === 'boolean'
              ? packageTestItem.is_active
              : null,
      };
    }

    return { testId: null, isActive: null };
  };

  const isConditionalFeeMatchedInCarts = (cartItems = [], feeConfig = {}) => {
    if (!cartItems || cartItems.length === 0) {
      return false;
    }

    const targetTestStatus = feeConfig.inactive_test ? false : true;
    const targetTestId = feeConfig.test ? parseInt(feeConfig.test) : null;

    return cartItems.some((cart) => {
      const meta = getCartTestMeta(cart);
      if (typeof meta.isActive !== 'boolean') {
        return false;
      }
      if (meta.isActive !== targetTestStatus) {
        return false;
      }
      if (targetTestId) {
        return meta.testId === targetTestId;
      }
      return true;
    });
  };

  const getBaseCollectionFee = (feeConfig = {}, isConditionMatched = false) => {
    const normalFee = parseInt(feeConfig.collection_fee) || 0;
    const extendedFee = parseInt(feeConfig.collection_fee_extend) || 0;
    const hasExtendedFee = extendedFee > 0;
    if (!hasExtendedFee) {
      return normalFee;
    }
    return isConditionMatched ? extendedFee : normalFee;
  };

  const getPrioritizedFeeRule = (rules = [], cartItems = []) => {
    if (!rules.length) {
      return getDefaultFeeConfig();
    }
    if (!cartItems.length) {
      const latestGenericRule = rules.find((rule) => !rule.test && !rule.inactive_lab);
      if (latestGenericRule) {
        return latestGenericRule;
      }
      return getDefaultFeeConfig();
    }

    const includeDelivery = deliveryCopy !== 'soft';
    const getRulePriorityAmount = (rule = {}) => {
      const baseCollectionFee = getBaseCollectionFee(rule, true);
      const deliveryFee = parseInt(rule.delivery_fee) || 0;
      return includeDelivery ? baseCollectionFee + deliveryFee : baseCollectionFee;
    };

    const pickHighestPricedRule = (matchedRules = []) => {
      if (!matchedRules.length) {
        return null;
      }
      return matchedRules.reduce((bestRule, currentRule) => {
        if (!bestRule) {
          return currentRule;
        }
        const bestAmount = getRulePriorityAmount(bestRule);
        const currentAmount = getRulePriorityAmount(currentRule);
        if (currentAmount > bestAmount) {
          return currentRule;
        }
        return bestRule;
      }, matchedRules[0]);
    };

    const matchedSpecificRules = rules.filter(
      (rule) => !!rule.test && isConditionalFeeMatchedInCarts(cartItems, rule)
    );
    const bestSpecificRule = pickHighestPricedRule(matchedSpecificRules);
    if (bestSpecificRule) {
      return bestSpecificRule;
    }

    const matchedGenericRules = rules.filter(
      (rule) => !rule.test && isConditionalFeeMatchedInCarts(cartItems, rule)
    );
    const bestGenericRule = pickHighestPricedRule(matchedGenericRules);
    if (bestGenericRule) {
      return bestGenericRule;
    }

    const latestGenericRule = rules.find((rule) => !rule.test);
    if (latestGenericRule) {
      return latestGenericRule;
    }

    return getDefaultFeeConfig();
  };

  // Material fee rate that applies to one patient, based only on that
  // patient's own tests (reuses the existing rule-matching engine, just
  // scoped to one patient instead of the whole cart).
  const getMaterialFeeForItems = (items = []) => {
    const rule = getPrioritizedFeeRule(feeRules || [], items);
    return parseInt(rule.meterial_fee) || 0;
  };

  // Order-wide material fee total: each distinct patient's own rate, summed
  // once per patient (not once per test item).
  const getGroupedMaterialFeeTotal = (cartItems = []) => {
    const groups = {};
    (cartItems || []).forEach((cart) => {
      const patientId = cart && cart.patient && cart.patient.id;
      if (patientId == null) return;
      if (!groups[patientId]) {
        groups[patientId] = [];
      }
      groups[patientId].push(cart);
    });
    return Object.keys(groups).reduce(
      (total, patientId) => total + getMaterialFeeForItems(groups[patientId]),
      0
    );
  };

  const calculateLabDiscount = (array) => {
    // console.log(array);
    // console.log(carts);
    const eligibleDiscounts = getEligibleLabDiscounts(array);
    if (eligibleDiscounts.length === 0) {
      setLabDiscount(null);
      return;
    }

    let labMatched = false;

    carts.forEach((test) => {
      let matchedLabs = [];
      if (test.order_type === 'diagnostic') {
        const matched = eligibleDiscounts.find((coupon) => {
          return (
            test.test_item.branch.lab.name.toLowerCase() ===
            coupon.lab.name.toLowerCase()
          );
        });
        if (matched) {
          matchedLabs.push(matched);
        }
      } else if (test.order_type === 'package') {
        const matched = eligibleDiscounts.find((coupon) => {
          return (
            test.package.test_item.branch.lab.name.toLowerCase() ===
            coupon.lab.name.toLowerCase()
          );
        });
        if (matched) {
          matchedLabs.push(matched);
        }
      }

      if (matchedLabs.length !== 0) {
        labMatched = true;
      }
    });

    if (labMatched) {
      // console.log('continue for next step');

      let matchedTests = [];
      let matchedPackages = [];

      eligibleDiscounts.forEach((labTest) => {
        let single = [];
        labTest.cct_lab.forEach((test) => {
          let existing = carts
            .filter((cart) => cart.order_type === 'diagnostic')
            .filter(
              (cart) =>
                cart.test_item.diagnostic_test.id === test.test.id &&
                cart.test_item.branch.lab.id === labTest.lab.id
            )
            .map((cart) => {
              return {
                ...cart,
                criteria: labTest.criteria,
                rate: labTest.rate,
                is_collection_fee: labTest.is_collection_fee,
                is_material_fee: labTest.is_material_fee,
                material_rate_percentage: labTest.material_rate_percentage,
              };
            });

          if (existing) {
            single.push(...existing);
          }
        });
        matchedTests.push(...single);
      });
      eligibleDiscounts.forEach((labTest) => {
        let single = [];
        labTest.ccp_lab.forEach((test) => {
          let existing = carts
            .filter((cart) => cart.order_type === 'package')
            .filter(
              (cart) =>
                cart.package.package.id === test.package.id &&
                cart.package.test_item.branch.lab.id === labTest.lab.id
            )
            .map((cart) => {
              return {
                ...cart,
                criteria: labTest.criteria,
                rate: labTest.rate,
                is_collection_fee: labTest.is_collection_fee,
                is_material_fee: labTest.is_material_fee,
                material_rate_percentage: labTest.material_rate_percentage,
              };
            });

          if (existing) {
            single.push(...existing);
          }
        });
        matchedPackages.push(...single);
      });

      // const testIds = matchedTests.map((o) => o.test_item.id);
      // matchedTests = matchedTests.filter(
      //   (item, index) => !testIds.includes(item.test_item.id, index + 1)
      // );

      matchedTests = matchedTests.filter(
        (tag, index, array) =>
          array.findIndex(
            (t) =>
              t.test_item.id === tag.test_item.id &&
              t.patient.id === tag.patient.id
          ) === index
      );

      // const packageIds = matchedPackages.map((o) => o.package.test_item.id);
      // matchedPackages = matchedPackages.filter(
      //   (item, index) =>
      //     !packageIds.includes(item.package.test_item.id, index + 1)
      // );

      matchedPackages = matchedPackages.filter(
        (tag, index, array) =>
          array.findIndex(
            (t) =>
              t.package.test_item.id === tag.package.test_item.id &&
              t.patient.id === tag.patient.id
          ) === index
      );

      const allItems = [...matchedTests, ...matchedPackages];
      // console.log(allItems);

      let itemMaterial = 0,
        itemColletion = 0;

      const checkCollection = allItems.map((item) => item.is_collection_fee);
      checkCollection.includes(true)
        ? (itemColletion = 0)
        : (itemColletion =
            deliveryCopy === 'soft'
              ? feesApi.collection_fee
              : feesApi.collection_fee + feesApi.delivery_fee);

      const checkMaterial = allItems
        .filter((item) => {
          return item.is_material_fee;
        })
        .sort(
          (a, b) =>
            parseFloat(b.material_rate_percentage) -
            parseFloat(a.material_rate_percentage)
        );
      if (checkMaterial.length !== 0) {
        // console.log(checkMaterial[0]);
        itemMaterial =
          fees.meterial_fee -
          (fees.meterial_fee * checkMaterial[0].material_rate_percentage) / 100;
      } else {
        itemMaterial = fees.meterial_fee;
      }

      // console.log(itemColletion, itemMaterial);
      setFees({ meterial_fee: itemMaterial, collection_fee: itemColletion });
      setTimeout(() => {
        serviceFeesRemove(carts);
      }, 300);

      // console.log(cartCheckout);
      const newCart = carts.map((cart) => {
        const matched = matchedTests.find(
          (test) =>
            test.patient === cart.patient && test.test_item === cart.test_item
        );
        // copy the match so duplicate rows never share one object reference
        return matched ? { ...matched } : cart;
      });
      setCartCheckout(newCart);
      // console.log(newCart);
      // this.setState({ carts: newCart });
      setTimeout(() => {
        serviceFeesRemove(carts);
      }, 300);

      const newCart1 = newCart.map((cart) => {
        const matched = matchedPackages.find(
          (test) => test.patient === cart.patient && test.package === cart.package
        );
        // copy the match so duplicate rows never share one object reference
        return matched ? { ...matched } : cart;
      });
      // this.setState({ carts: newCart1 });
      setCartCheckout(newCart1);
      setTimeout(() => {
        serviceFeesRemove(carts);
      }, 300);

      const discountTestPrice = matchedTests.reduce((total, item) => {
        if (item.criteria === 'perchantange') {
          return (
            total +
            (parseInt(item.test_item.purchasable_order_item.sell_price) *
              parseInt(item.rate)) /
              100
          );
        } else {
          return total + parseInt(item.rate);
        }
      }, 0);

      const discountPackagePrice = matchedPackages.reduce((total, item) => {
        if (item.criteria === 'perchantange') {
          return (
            total +
            (parseInt(item.package.package.purchasable_order_item.sell_price) *
              parseInt(item.rate)) /
              100
          );
        } else {
          return total + parseInt(item.rate);
        }
      }, 0);

      const discountPrice = discountTestPrice + discountPackagePrice;

      if (discountPrice && 0 < discountPrice) {
        setLabDiscount(discountPrice);
        // console.log(discountTestPrice);
      } else {
        setLabDiscount(null);
      }
    } else {
      setLabDiscount(null);
    }
  };

  const serviceFeesRemove = (array) => {
    const testItems = array
      .filter((item) => {
        return item.order_type === 'diagnostic';
      })
      .map((item) => {
        return item.test_item.diagnostic_test.name;
      });

    const checkOne = testItems.includes('Covid RT PCR');
    const checkTwo = testItems.includes('Covid Antigen');

    // console.log(checkTwo);
    if (checkOne || checkTwo) {
      setFees({ meterial_fee: 0, collection_fee: 0, delivery_fee: 0 });
    } else if (array && array.length && array[0].order_type === 'package') {
      setFees({ meterial_fee: 0, collection_fee: 0, delivery_fee: 0 });
    }
  };

  const getFees = (cartItems = []) => {
    axios
      .get(`${process.env.REACT_APP_BASE_URL}/diagnostic/fees/?limit=200`)
      .then((resp) => {
        const feeRules = getFeeConfigsFromApi(resp);
        const selectedRule = getPrioritizedFeeRule(feeRules, cartItems || []);
        const isConditionMatched = isConditionalFeeMatchedInCarts(
          cartItems || [],
          selectedRule
        );
        const baseCollectionFee = getBaseCollectionFee(
          selectedRule,
          isConditionMatched
        );
        const normalizedFeeConfig = {
          ...selectedRule,
          collection_fee: baseCollectionFee,
        };
        const totalCollectionFee =
          deliveryCopy === 'soft'
            ? baseCollectionFee
            : baseCollectionFee + normalizedFeeConfig.delivery_fee;

        setFeesApi(normalizedFeeConfig);
        setFeeRules(feeRules);
        setFees({
          collection_fee: totalCollectionFee,
          meterial_fee: normalizedFeeConfig.meterial_fee,
          delivery_fee: normalizedFeeConfig.delivery_fee,
        });
        setTimeout(() => {
          serviceFeesRemove(cartItems || []);
        }, 300);
      })
      .catch((error) => {});
  };

  const handleMeterialPerson = (array) => {
    const patients = array
      .map((patient) => {
        return patient.patient.id;
      })
      .filter((x, i, a) => a.indexOf(x) === i);
    // console.log(patients.length);
    setMaterialPerson(patients.length);
  };

  const handlePatientOrders = (order) => {
    const itemArray = order;
    const patientDetails = itemArray.map((item) => item.patient);
    const ids = patientDetails.map((o) => o.id);
    const filteredPatient = patientDetails.filter(
      ({ id }, index) => !ids.includes(id, index + 1)
    );
    // console.log(itemArray);
    //   console.log(filteredPatient);
    let patientOrders = [];

    filteredPatient.forEach((patient) => {
      const result = itemArray.filter((o1) => {
        return o1.patient.id === patient.id;
      });
      const newArray = {
        patient: patient,
        testItem: result,
      };
      patientOrders.push(newArray);
      // console.log(newArray);
    });
    patientOrders.sort((p) => (p.patient.is_account ? -1 : 1));
    // setCtCPatient(patientOrders);
    setPatinetOrders(patientOrders);
    // console.log(patientOrders);
  };

  const getPatTestPrice = (testItem) => {
    if (testItem.length !== 0) {
      if (testItem[0].order_type === 'package') {
        const price = testItem.reduce((total, item) => {
          return (
            total +
            parseInt(item.package.test_item.purchasable_order_item.sell_price)
          );
        }, 0);
        return price;
      } else {
        const price = testItem.reduce((total, item) => {
          return (
            total + parseInt(item.test_item.purchasable_order_item.sell_price)
          );
        }, 0);
        return price;
      }
    } else {
      return '00';
    }
  };

  const getTotalPrice = (array) => {
    const diagnosticrr = array.filter((diag) => {
      return diag.order_type === 'diagnostic';
    });

    const packagerr = array.filter((diag) => {
      return diag.order_type === 'package';
    });

    const diagprice = diagnosticrr.reduce(
      (total, item) =>
        total + parseInt(item.test_item.purchasable_order_item.sell_price),
      0
    );

    const packprice = packagerr.reduce(
      (total, item) =>
        total +
        parseInt(item.package.test_item.purchasable_order_item.sell_price),
      0
    );

    return diagprice + packprice;
  };

  const deleteCartItem = (cart) => {
    // console.log(cart);

    const newCarts = [...carts];
    const filterCart = newCarts.filter((single) => single !== cart);
    setCartsItem(filterCart);
    // console.log(filterCart);
    if (filterCart.length === 0) {
      localStorage.removeItem('lab_name');
      localStorage.removeItem('lab_location');
      setIsLocalLab(false);
      setLastCartPatient([]);
      localStorage.removeItem('lastCartPatient');
    } else {
      // setTimeout(() => {
      //   if (labDiscountArray) {
      //     calculateLabDiscount(labDiscountArray);
      //   }
      //   console.log(carts);
      // }, 1000);
    }

    const localCarts = localStorage.getItem('order');
    if (localCarts) {
      const allCarts = JSON.parse(localCarts);

      const newData = {
        user: allCarts.user,
        status: '',
        order_item: filterCart,
      };

      localStorage.setItem('order', JSON.stringify(newData));
    }
  };

  const getTotalPriceWithFees = (array) => {
    const diagnosticrr = array.filter((diag) => {
      return diag.order_type === 'diagnostic';
    });

    const packagerr = array.filter((diag) => {
      return diag.order_type === 'package';
    });

    const diagprice = diagnosticrr.reduce(
      (total, item) =>
        total + parseInt(item.test_item.purchasable_order_item.sell_price),
      0
    );

    const packprice = packagerr.reduce(
      (total, item) =>
        total +
        parseInt(item.package.test_item.purchasable_order_item.sell_price),
      0
    );
    const totalPrice =
      diagprice +
      packprice +
      fees.collection_fee +
      getGroupedMaterialFeeTotal(array);
    return totalPrice;
  };

  const getTotalPriceWithFeesWithCoupon = (array) => {
    const diagnosticrr = array.filter((diag) => {
      return diag.order_type === 'diagnostic';
    });

    const packagerr = array.filter((diag) => {
      return diag.order_type === 'package';
    });

    const diagprice = diagnosticrr.reduce(
      (total, item) =>
        total + parseInt(item.test_item.purchasable_order_item.sell_price),
      0
    );

    const packprice = packagerr.reduce(
      (total, item) =>
        total +
        parseInt(item.package.test_item.purchasable_order_item.sell_price),
      0
    );
    const totalPrice =
      diagprice +
      packprice +
      fees.collection_fee +
      getGroupedMaterialFeeTotal(array);
    if (discountAmount && labDiscount) {
      return totalPrice - discountAmount - labDiscount;
    } else if (labDiscount) {
      return totalPrice - labDiscount;
    } else if (discountAmount) {
      return totalPrice - discountAmount;
    } else {
      return totalPrice;
    }
  };

  /*
   * Range coupons are a batch of codes sharing a prefix - e.g. code "AMARLAB"
   * with start 10001 and end 10500 means AMARLAB10001 ... AMARLAB10500.
   */
  const coupontRange = (x, y, str) => {
    const numbers = [];
    for (let i = x; i <= y; i++) {
      numbers.push(`${str}${i}`);
    }
    return numbers;
  };

  /*
   * Every coupon that the plain lookup rejects ends up here, including every
   * invalid code. This was copied from the class component in Checkout.js and
   * still read this.state / this.coupontRange / this.cuponAndCartMatch - in a
   * function component `this` is undefined, so it threw on its first line:
   * an invalid code showed no message at all, and range coupons could never
   * be applied from the cart. Now uses this component's own state.
   */
  const couponRangeCheck = () => {
    const letter = coupon.match(/[a-zA-Z]+/g);
    const number = coupon.match(/\d+/g);
    if (!letter) {
      toast.error('Sorry, this coupon is not valid.');
      return;
    }

    // console.log(letter);
    // console.log(number);

    axios
      .get(`${process.env.REACT_APP_BASE_URL}/diagnostic/cupon/?code=${letter}`)
      .then((resp) => {
        if (resp.data.results.length !== 0) {
          const data = resp.data.results
            .filter((coupon) => coupon.is_active)
            .filter((coupon) => {
              const expire_day = moment(coupon.expired_at)
                .add(1, 'days')
                .format('YYYY-MM-DD')
                .toString();
              const isSameOrAfter = moment(expire_day).isSameOrAfter(
                moment().format('YYYY-MM-DD')
              );

              if (isSameOrAfter) {
                return coupon;
              }
            })
            .filter((coupon) => isLabDiscountAllowedForUser(coupon));

          if (data.length === 0) {
            toast.error('Sorry, this coupon is not valid.');
          } else {
            // console.log(data);
            const cartLab = cartCheckout.map((cart) =>
              cart.order_type === 'diagnostic'
                ? cart.test_item.branch.lab.id
                : cart.package.test_item.branch.lab.id
            );
            const cartLabId = cartLab[0];

            if (1 < data.length) {
              const getCouponLab = data.filter((labs) =>
                labs.ccl.some((lab) => lab.lab === cartLabId)
              );

              if (getCouponLab.length !== 0) {
                // cuponAndCartMatch(getCouponLab.at(-1));
                const couponDet = getCouponLab.at(-1);
                if (couponDet.is_code_range) {
                  // console.log(couponDet);

                  const array = coupontRange(
                    couponDet.code_start,
                    couponDet.code_end,
                    couponDet.code
                  );
                  // console.log(array.includes(coupon));
                  if (array.includes(coupon)) {
                    cuponAndCartMatch(couponDet);
                  } else {
                    toast.error('Sorry, this coupon is not valid.');
                  }
                  // array.includes('amarlab10000');
                } else {
                  toast.error('Sorry, this coupon is not valid.');
                }
              } else {
                toast.error('Sorry, this coupon is not valid.');
              }
            } else {
              if (data[0].is_code_range) {
                const couponDet = data[0];
                // console.log(couponDet);
                if (couponDet.is_code_range) {
                  // console.log(couponDet);

                  const array = coupontRange(
                    couponDet.code_start,
                    couponDet.code_end,
                    couponDet.code
                  );
                  // console.log(array.includes(coupon));
                  if (array.includes(coupon)) {
                    cuponAndCartMatch(couponDet);
                  } else {
                    toast.error('Sorry, this coupon is not valid.');
                  }
                  // array.includes('amarlab10000');
                } else {
                  toast.error('Sorry, this coupon is not valid.');
                }
              } else {
                toast.error('Sorry, this coupon is not valid.');
              }
            }
          }
        } else {
          toast.error('Sorry, this coupon is not valid.');
        }
      })
      .catch(() => {
        toast.error('Sorry, this coupon is not valid.');
      });
  };

  const cuponAndCartMatch = (data) => {
    // console.log(data);
    if (!isLabDiscountAllowedForUser(data)) {
      toast.error('Sorry, coupon is not valid.');
      return;
    }

    let newCollectionFees, newMaterialFees;
    data.is_collection_fee
      ? (newCollectionFees = 0)
      : (newCollectionFees = fees.collection_fee);

    data.is_material_fee
      ? (newMaterialFees =
          fees.meterial_fee -
          (fees.meterial_fee * data.material_rate_percentage) / 100)
      : (newMaterialFees = fees.meterial_fee);

    setFees({
      meterial_fee: newMaterialFees,
      collection_fee: newCollectionFees,
    });

    const diagnostics = cartCheckout.filter((diagnostic) => {
      return diagnostic.order_type === 'diagnostic';
    });
    const packages = cartCheckout.filter((name) => {
      return name.order_type === 'package';
    });

    let cartLabs = [];

    if (diagnostics.length !== 0) {
      const labDetails = diagnostics.map((lab) => {
        return {
          labName: lab.test_item.branch.lab.name,
          id: lab.test_item.branch.lab.id,
        };
      });
      // console.log(labDetails);
      cartLabs.push(...labDetails);
    } else {
      const labDetails = packages.map((lab) => {
        return {
          labName: lab.package.test_item.branch.lab.name,
          id: lab.package.test_item.branch.lab.id,
        };
      });
      // console.log(labDetails);
      cartLabs.push(...labDetails);
    }

    let cartBranches = [];

    if (diagnostics.length !== 0) {
      const labDetails = diagnostics.map((lab) => {
        return {
          branchName: lab.test_item.branch.name,
          id: lab.test_item.branch.id,
        };
      });
      // console.log(labDetails);
      cartBranches.push(...labDetails);
    } else {
      const labDetails = packages.map((lab) => {
        return {
          branchName: lab.package.test_item.branch.name,
          id: lab.package.test_item.branch.id,
        };
      });
      // console.log(labDetails);
      cartBranches.push(...labDetails);
    }

    const cuponTests = data.cct;
    const cuponPackages = data.ccp;
    const cuponLabs = data.ccl;
    const cuponBranches = data.ccb;

    let matchedTests = [];
    cuponTests.forEach((cupId) => {
      let existing = diagnostics.filter(
        (diagId) => diagId.test_item.diagnostic_test.id === cupId.test
      );

      if (existing) {
        matchedTests.push(...existing);
      }
    });

    let matchedPackages = [];
    cuponPackages.forEach((cupId) => {
      let existing = packages.filter(
        (packId) => packId.package.package.id === cupId.package
      );

      if (existing) {
        matchedPackages.push(...existing);
      }
    });

    let matchedLabs = [];
    cuponLabs.forEach((cupId) => {
      let existing = cartLabs.find((packId) => packId.id === cupId.lab);

      if (existing) {
        matchedLabs.push(existing);
      }
    });

    let matchedBranches = [];
    cuponBranches.forEach((cupId) => {
      let existing = cartBranches.find((packId) => packId.id === cupId.branch);

      if (existing) {
        matchedBranches.push(existing);
      }
    });

    // console.log('Tests: ', matchedTests);
    // console.log('Packages: ', matchedPackages);
    // console.log('Labs: ', matchedLabs);

    if (data.is_branch) {
      // console.log('Calculate Branch');
      // console.log(data);
      // console.log('Tests: ', matchedTests);
      // console.log('Packages: ', matchedPackages);
      // console.log('Branches: ', matchedBranches);

      if (matchedBranches.length !== 0) {
        const priceArray = [...matchedTests, ...matchedPackages];
        const percentAmount = getTotalPrice(priceArray) * (data.rate / 100);
        setDiscountAmount(parseInt(percentAmount));

        const newTestCart = [...matchedTests].map((cart) => {
          return {
            ...cart,
            criteria: data.criteria,
            rate: cart.rate ? cart.rate + data.rate : data.rate,
            is_collection_fee: cart.is_collection_fee
              ? cart.is_collectio
              : data.is_collection_fee,
            is_material_fee: cart.is_material_fee
              ? cart.is_material_fee
              : data.is_material_fee,
            material_rate_percentage: cart.material_rate_percentage
              ? cart.material_rate_percentage + data.material_rate_percentage
              : data.material_rate_percentage,
          };
        });

        const newPackageCart = [...matchedPackages].map((cart) => {
          return {
            ...cart,
            criteria: data.criteria,
            rate: cart.rate ? cart.rate + data.rate : data.rate,
            is_collection_fee: cart.is_collection_fee
              ? cart.is_collectio
              : data.is_collection_fee,
            is_material_fee: cart.is_material_fee
              ? cart.is_material_fee
              : data.is_material_fee,
            material_rate_percentage: cart.material_rate_percentage
              ? cart.material_rate_percentage + data.material_rate_percentage
              : data.material_rate_percentage,
          };
        });

        const newCart = cartCheckout.map(
          (cart) => {
            // Copy, like Checkout.js: duplicate rows must stay distinct objects,
            // because cart rows are deleted by object identity.
            const matched = newTestCart.find(
              (test) =>
                test.patient === cart.patient &&
                test.test_item === cart.test_item
            );
            return matched ? { ...matched } : cart;
          }
        );
        setCartCheckout(newCart);
        setTimeout(() => {
          serviceFeesRemove(cartCheckout);
        }, 300);

        const newCart1 = cartCheckout.map(
          (cart) => {
            // Copy, like Checkout.js: duplicate rows must stay distinct objects,
            // because cart rows are deleted by object identity.
            const matched = newPackageCart.find(
              (test) =>
                test.patient === cart.patient && test.package === cart.package
            );
            return matched ? { ...matched } : cart;
          }
        );
        setCartCheckout(newCart1);
        setTimeout(() => {
          serviceFeesRemove(cartCheckout);
        }, 300);

        setShowDiscount(true);
        toast.success('Congratulation, coupon matched.', {
          autoClose: 3000,
        });
        setcuponId(data.id);
      } else {
        toast.error('Sorry, coupon is not valid.');
      }
    } else {
      if (
        data.cca.length === 0 &&
        // data.ccl.length === 0 &&
        data.ccp.length === 0 &&
        data.cct.length === 0
      ) {
        if (data.criteria === 'static') {
          setDiscountAmount(data.rate);
        } else {
          const percentAmount = getTotalPrice(cartCheckout) * (data.rate / 100);
          // console.log(parseInt(percentAmount));
          setDiscountAmount(parseInt(percentAmount));
        }

        const newCart = cartCheckout.map((cart) => {
          return {
            ...cart,
            criteria: data.criteria,
            rate: cart.rate ? cart.rate + data.rate : data.rate,
            is_collection_fee: cart.is_collection_fee
              ? cart.is_collectio
              : data.is_collection_fee,
            is_material_fee: cart.is_material_fee
              ? cart.is_material_fee
              : data.is_material_fee,
            material_rate_percentage: cart.material_rate_percentage
              ? cart.material_rate_percentage + data.material_rate_percentage
              : data.material_rate_percentage,
          };
        });
        setCartCheckout(newCart);
        setTimeout(() => {
          serviceFeesRemove(cartCheckout);
        }, 300);

        toast.success('Congratulation, coupon matched.', {
          autoClose: 3000,
        });
        setShowDiscount(true);
        setcuponId(data.id);
      } else if (matchedTests.length !== 0 || matchedPackages.length !== 0) {
        if (data.criteria === 'static') {
          setDiscountAmount(data.rate);
        } else {
          const priceArray = [...matchedTests, ...matchedPackages];
          // console.log(priceArray);
          const percentAmount = getTotalPrice(priceArray) * (data.rate / 100);
          // console.log(percentAmount);
          setDiscountAmount(parseInt(percentAmount));
        }

        const newTestCart = [...matchedTests].map((cart) => {
          return {
            ...cart,
            criteria: data.criteria,
            rate: cart.rate ? cart.rate + data.rate : data.rate,
            is_collection_fee: cart.is_collection_fee
              ? cart.is_collectio
              : data.is_collection_fee,
            is_material_fee: cart.is_material_fee
              ? cart.is_material_fee
              : data.is_material_fee,
            material_rate_percentage: cart.material_rate_percentage
              ? cart.material_rate_percentage + data.material_rate_percentage
              : data.material_rate_percentage,
          };
        });

        const newPackageCart = [...matchedPackages].map((cart) => {
          return {
            ...cart,
            criteria: data.criteria,
            rate: cart.rate ? cart.rate + data.rate : data.rate,
            is_collection_fee: cart.is_collection_fee
              ? cart.is_collectio
              : data.is_collection_fee,
            is_material_fee: cart.is_material_fee
              ? cart.is_material_fee
              : data.is_material_fee,
            material_rate_percentage: cart.material_rate_percentage
              ? cart.material_rate_percentage + data.material_rate_percentage
              : data.material_rate_percentage,
          };
        });

        const newCart = cartCheckout.map(
          (cart) => {
            // Copy, like Checkout.js: duplicate rows must stay distinct objects,
            // because cart rows are deleted by object identity.
            const matched = newTestCart.find(
              (test) =>
                test.patient === cart.patient &&
                test.test_item === cart.test_item
            );
            return matched ? { ...matched } : cart;
          }
        );
        setCartCheckout(newCart);
        setTimeout(() => {
          serviceFeesRemove(cartCheckout);
        }, 300);

        const newCart1 = cartCheckout.map(
          (cart) => {
            // Copy, like Checkout.js: duplicate rows must stay distinct objects,
            // because cart rows are deleted by object identity.
            const matched = newPackageCart.find(
              (test) =>
                test.patient === cart.patient && test.package === cart.package
            );
            return matched ? { ...matched } : cart;
          }
        );

        setTimeout(() => {
          setCartCheckout(newCart1);
          serviceFeesRemove(cartCheckout);
        }, 300);

        setShowDiscount(true);
        toast.success('Congratulation, coupon matched.', {
          autoClose: 3000,
        });
        setcuponId(data.id);
      } else {
        toast.error('Sorry, coupon is not valid.', {
          autoClose: 3000,
        });
      }
    }
  };

  const fetchCoupon = (code) => {
    axios
      .get(`${process.env.REACT_APP_BASE_URL}/diagnostic/cupon/?code=${code}`)
      .then((resp) => {
        // console.log(resp.data.results);
        const today = moment().format('YYYY-MM-DD');
        if (resp.data.results.length !== 0) {
          const data = resp.data.results
            .filter((coupon) => coupon.is_active)
            .filter((coupon) => {
              const expire_day = moment(coupon.expired_at)
                .add(1, 'days')
                .format('YYYY-MM-DD')
                .toString();
              const isSameOrAfter = moment(expire_day).isSameOrAfter(today);

              if (isSameOrAfter) {
                return coupon;
              }
            })
            .filter((coupon) => isLabDiscountAllowedForUser(coupon));

          if (data.length === 0) {
            // toast.error('Sorry, this coupon is not valid.');
            couponRangeCheck();
          } else {
            // console.log('do something with coupon');
            // this.cuponAndCartMatch(data);
            const cartLab = cartCheckout.map((cart) =>
              cart.order_type === 'diagnostic'
                ? cart.test_item.branch.lab.id
                : cart.package.test_item.branch.lab.id
            );
            const cartLabId = cartLab[0];
            // console.log(data);
            // console.log(cartLabId);

            if (1 < data.length) {
              const getCouponLab = data.filter((labs) =>
                labs.ccl.some((lab) => lab.lab === cartLabId)
              );
              // console.log(getCouponLab);
              if (getCouponLab.length !== 0) {
                // console.log(getCouponLab.at(-1).is_code_range);
                if (!getCouponLab.at(-1).is_code_range) {
                  cuponAndCartMatch(getCouponLab.at(-1));
                } else {
                  // toast.error('Sorry, this coupon is not valid.');
                  couponRangeCheck();
                }
              } else {
                // toast.error('Sorry, this coupon is not valid.');
                couponRangeCheck();
              }
            } else {
              if (!data[0].is_code_range) {
                cuponAndCartMatch(data[0]);
              } else {
                // toast.error('Sorry, this coupon is not valid.');
                couponRangeCheck();
              }
            }
          }
        } else {
          // toast.error('Sorry, this coupon is not valid.', {
          //   autoClose: 3000,
          // });
          couponRangeCheck();
        }
      })
      .catch((error) => {
        couponRangeCheck();
      });
  };

  const handleCoupon = (e) => {
    e.preventDefault();
    if (coupon.trim() === '') {
      toast.error('Please enter coupon code.', {
        autoClose: 3000,
      });
    } else {
      fetchCoupon(coupon);
    }
  };

  return (
    <div className='cart-p-mbl'>
      {patinetOrders && patinetOrders.length !== 0 ? (
        <>
          {patinetOrders.map((item, i) => (
            <div className='single' key={i}>
              <div className='patient'>
                <div>
                  <span className='font-semibold'>Patient: </span>{' '}
                  {item.patient.full_name}, {item.patient.sex},{' '}
                  {item.patient.dob
                    ? moment().diff(`${item.patient.dob}`, 'years') + 'y'
                    : ''}
                </div>
                <div className='price font-semibold'>
                  ৳ {getPatTestPrice(item.testItem)}
                </div>
              </div>
              <div className='tests'>
                <ul>
                  {item.testItem.length !== 0 &&
                    item.testItem.map((test, i) => (
                      <li key={i}>
                        <span className='font-semibold'>
                          {test && test.order_type === 'diagnostic'
                            ? test.test_item.diagnostic_test && test.test_item.diagnostic_test.name
                            : test.package.package.name}
                        </span>
                        <div className='las'>
                          <span>
                            ৳{' '}
                            {test.order_type === 'diagnostic'
                              ? parseInt(
                                  test.test_item.purchasable_order_item
                                    .sell_price
                                )
                              : parseInt(
                                  test.package.test_item.purchasable_order_item
                                    .sell_price
                                )}
                          </span>
                          <i
                            className='far fa-trash-alt'
                            onClick={() => deleteCartItem(test)}
                          ></i>
                        </div>
                      </li>
                    ))}
                </ul>
                <p className='text-right' style={{ marginBottom: '24px' }}>
                  <Link
                    to={{
                      pathname:
                        cartOrderType === 'diagnostic'
                          ? '/diagnostic'
                          : '/packages',
                      params: {
                        formCartPage: true,
                        showPatient: [item.patient],
                      },
                    }}
                    className='add-an-btn'
                  >
                    Add Another
                  </Link>
                </p>
              </div>
            </div>
          ))}

          <div className='another-pat'>
            <Link
              to={{
                pathname:
                  cartOrderType === 'diagnostic' ? '/diagnostic' : '/packages',
                params: {
                  formCartPage: true,
                  showPatient: [],
                },
              }}
            >
              Add Tests For Another Patient
              <i className='fas fa-arrow-right'></i>
            </Link>
          </div>

          <div className='have-code'>
            <p
              className='text-center m-0'
              onClick={() => setShowCouponSection(!showCouponSection)}
            >
              {showCouponSection ? (
                <i className='fas fa-chevron-up'></i>
              ) : (
                <i className='fas fa-chevron-down'></i>
              )}
              Have A Special Code?
            </p>
            {showCouponSection && (
              <form className='input-code' onSubmit={handleCoupon}>
                <input
                  type='text'
                  placeholder='Special Code'
                  value={coupon}
                  onChange={(e) => setCoupon(e.target.value)}
                />
                <button disabled={showDiscount ? 'disabled' : ''}>
                  {showDiscount ? 'Applied' : 'Apply'}
                </button>
              </form>
            )}
          </div>

          <div className='checkout-btn'>
            <div className='left'>
              <p className='tp'>Total Payable</p>
              <div className='bd'>
                <p className='tk'>৳ {getTotalPriceWithFeesWithCoupon(carts)}</p>
                <p className='vd' onClick={() => setShowPaymentViewMore(true)}>
                  View Details
                </p>
              </div>
            </div>
            <div className='right'>
              <Link
                className='btn btn-primary'
                to={{
                  pathname: '/checkout',
                  params: {
                    carts: cartCheckout,
                    fees: fees,
                    feesApi: feesApi,
                    labDiscount: labDiscount,
                    discountAmount: discountAmount,
                    coupon: coupon,
                    cuponId: cuponId,
                    showDiscount: showDiscount,
                  },
                }}
              >
                Checkout
              </Link>
            </div>
          </div>
        </>
      ) : (
        <div className='empty'>
          <div className='details'>
            <img src={CartIcon} alt='' className='cart-icon' />
            <p className='ce'>Your cart is empty</p>
            {/* <p className='dt'>
              A medical technologist will be assigned to your order.
            </p> */}
            <p className='dt'>
              Please add tests or packages to your cart.
            </p>
            <p className='text-center m-0'>
              <Link to='/diagnostic' className='btn btn-primary'>
                Start Ordering
              </Link>
            </p>
          </div>
        </div>
      )}

      <Modal
        show={showPaymentViewMore}
        onHide={() => setShowPaymentViewMore(false)}
        animation={false}
        centered
        dialogClassName='app-modal'
      >
        <ModalBody>
          <div className='cart-payment-modal'>
            <div className='body'>
              <div className='header'>
                <p className='title'>Payment Details</p>
                <img
                  src={CrossImg}
                  alt=''
                  onClick={() => setShowPaymentViewMore(false)}
                />
              </div>
              <ul className='mai-p'>
                <li>
                  <span>Cost of Diagnostics</span>
                  <span>৳ {getTotalPrice(carts)}</span>
                </li>
                {carts &&
                  carts.length !== 0 &&
                  carts[0].order_type !== 'package' && (
                    <>
                      <li>
                        <span>Material Fee</span>
                        <span>৳ {getGroupedMaterialFeeTotal(carts)}</span>
                      </li>
                      <li>
                        <span>Collection Fee</span>
                        <span>৳ {fees.collection_fee}</span>
                      </li>
                    </>
                  )}
                <li>
                  <span className='font-semibold'>Sub Total</span>
                  <span className='font-semibold'>
                    ৳ {getTotalPriceWithFees(carts)}
                  </span>
                </li>
              </ul>
              <ul className='sub-p'>
                {labDiscount && (
                  <li>
                    <span>Discount on Diagnostics</span>
                    <span>- ৳ {labDiscount || '00'}</span>
                  </li>
                )}
                {showDiscount && (
                  <li>
                    <span>Coupon Code</span>
                    <span>- ৳ {discountAmount || '00'}</span>
                  </li>
                )}
                <li>
                  <span className='font-semibold'>Total Payable</span>
                  <span className='font-semibold'>
                    ৳ {getTotalPriceWithFeesWithCoupon(carts)}
                  </span>
                </li>
              </ul>
            </div>
          </div>
        </ModalBody>
      </Modal>
    </div>
  );
};

export default Cart;
